import ProgressBarChart from "../../../../components/progress-bart-chart";
import TableContent from "../../../../components/table-content";
import { ReactComponent as ArrowBackIcon } from '../../../../assets/icons/arrow-back.svg';
import { ReactComponent as UserIcon } from '../../../../assets/icons/user.svg';
import { ReactComponent as MerchantIcon } from '../../../../assets/icons/merchant.svg';
import { ReactComponent as CardIcon } from '../../../../assets/icons/processor-card.svg';
import { useNavigate, useParams } from "react-router-dom";
import './mid-transactions-page.scss';
import { useEffect, useState } from "react";
import { apiService } from "../../../../services/api.service";
import { useSelector } from "react-redux";
import { AppStore } from "../../../../store/store";
import { UserState } from "../../../../store/user.slice";
import dateService from "../../../../services/date.service";
import TablePagination from "../../../../components/table-pagination";
import { formatAmount } from "../../../../utils/number-utils";


interface MidDetails {
    id: string;
    name: string;
    limit: number;
    merchantName: string;
    processorName: string;
    percentUsage: number;
}



const MidTransactionsPage: React.FC = () => {
    const navigate = useNavigate();
    const { id } = useParams();

    const [transactions, setTransactions] = useState();
    const [transactionLoader, setTransactionLoader] = useState(false);

    const [midDetails, setMidDetails] = useState<MidDetails>();

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1)

    const { user } = useSelector<AppStore, UserState>((state) => state.user)

    const isMerchant = (user?.roles?.includes("merchant") || user?.roles?.includes("bas_merchant_view")) ?? false;



    const columnsMidTransactions = [
        {
            Header: 'Trace ID',
            accessor: 'id',
            Cell: ({ value }: { value: string }) => (
                <span
                    className="id-text truncated-text"
                    onClick={() => navigate(`/app/transactions/transaction/${value}`)}
                >{value}</span>
            ),
        },
        {
            Header: 'FROM Customer',
            accessor: 'customerName',
            Cell: ({ value, row }: { value: string; row: any }) => (
                <div className="flex-column flex-gap-5">
                    <div className="flex-row flex-gap-5 flex-align-start-center">
                        <UserIcon />
                        <span>{value}</span>
                    </div>
                    <div className="secondary-text accent-gradient-text">
                        {row.original.customerCardType} - xxxx xxxx xxxx {row.original.cardLast4}
                    </div>
                </div>
            ),
        },
        // {
        //     Header: 'TO Merchant',
        //     accessor: 'merchantName',
        //     Cell: ({ value, row }: { value: string; row: any }) => (
        //         <div className="flex-column flex-gap-5">
        //             <div className="flex-row flex-gap-5 flex-align-start-center">
        //                 <MerchantIcon />
        //                 <span>{value}</span>
        //             </div>
        //             <div className="secondary-text accent-gradient-text">{row.original.merchantId}</div>
        //         </div>
        //     ),
        // },
        {
            Header: 'Channel',
            accessor: 'processorName',
            Cell: ({ value, row }: { value: string; row: any }) => {

                return (
                    <div className="flex-column flex-gap-5">
                        <div className="flex-row flex-gap-5 flex-align-start-center">
                            <CardIcon />
                            <span>{row.original.processorName}</span>
                        </div>
                        <div className="secondary-text accent-gradient-text">{!isMerchant && row.original.processorTransactionId}</div>
                    </div>
                )
            },
        },
        {
            Header: 'Value',
            accessor: 'amount',
            Cell: ({ value }: { value: string }) => (
                <span className="value-text accent-gradient-text">${formatAmount(+value)}</span>
            ),
        },
        {
            Header: 'Status',
            accessor: 'status',
            Cell: ({ value, row }: { value: string; row: any }) => (
                <div
                    className={`status ${value.toLowerCase()}
                 flex-row flex-align-center-center`}
                    onClick={() => navigate(`/app/transactions/transaction/${row.original.id}`)}
                >
                    <span>{value}</span>
                </div>
            ),
        },
        {
            Header: 'Time',
            accessor: 'date',
            Cell: ({ value }: { value: string }) => (
                <div className="date-text">{dateService.formatDateForTable(value)}</div>
            ),
        },
    ];


    useEffect(() => {
        const getMidLimit = async () => {
            try {
                const response = await apiService.getMidLimitById(id!)
                return response.data;
            } catch (e) {

            }
        }
        const getMidTransactions = async () => {
            const pageInfo = {
                page: currentPage - 1,
                size: 10,
            };
            try {
                const response = await apiService.getTransactions({ midId: id }, pageInfo);
                return response.data
            } catch (e) {

            }
        }
        if (id) {

            getMidLimit().then((result) => {
                if (result)
                    setMidDetails(result)
            })

            setTransactionLoader(true)
            getMidTransactions()
                .then((result) => {
                    if (result) {
                        setTotalPages(result.totalPages);
                        setTransactions(result.content)
                    }
                })
                .finally(() => setTransactionLoader(false))
        }
    }, [id, user, currentPage])

    const handlePageChange = (newPage: number) => {
        setCurrentPage(newPage);
    };


    return (
        <div className="mid-transactions-page page-content">
            <div className="page-header flex-row flex-gap-10 flex-align-start-center">
                <ArrowBackIcon
                    className="back-icon"
                    onClick={() => navigate(-1)}
                />
                <div className='page-title'>
                    View Transactions - <span className="page-subtitle">{isMerchant? midDetails?.merchantName: midDetails?.name}</span>
                </div>

            </div>

            <div className='inner-page flex-column flex-gap-30 width-100'>
                <div className="total-chart flex-row flex-gap-20 flex-align-center-center">
                    <ProgressBarChart percent={midDetails?.percentUsage || 0} />
                    <span className="mid-total-value">{midDetails?.limit && formatAmount(+midDetails?.limit)}$</span>
                </div>
                <TableContent columns={columnsMidTransactions} data={transactions || []} isLoading={transactionLoader} />
                <TablePagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                />
            </div>

        </div>
    );
}

export default MidTransactionsPage;